
import Vue from 'vue'
import {
  Vuetify,
  VApp,
  VNavigationDrawer,
  VFooter,
  VList,
  VBtn,
  VIcon,
  VGrid,
  VToolbar,
  VMenu,
  VTextField,
  VSnackbar,
  VForm,
  VDataTable,
  VProgressLinear,
  VAlert,
  VDialog,
  VCard,
  VCheckbox,
  VSwitch,
  VDatePicker,
  VTimePicker,
  VSelect,
  VTextarea,
  transitions,
  VImg,
  VBadge,
  VExpansionPanel,
  VDivider,
  VProgressCircular,
  VSpeedDial,
} from 'vuetify'
import 'vuetify/src/stylus/app.styl'
import { i18n } from '../utils/locales/default';

Vue.use(Vuetify, {
  components: {
    VApp,
    VNavigationDrawer,
    VFooter,
    VList,
    VBtn,
    VIcon,
    VGrid,
    VToolbar,
    VMenu,
    VTextField,
    VSnackbar,
    VForm,
    VDataTable,
    VProgressLinear,
    VAlert,
    VDialog,
    VCard,
    VCheckbox,
    VSwitch,
    VDatePicker,
    VTimePicker,
    VSelect,
    VTextarea,
    transitions,
    VImg,
    VBadge,
    VExpansionPanel,
    VDivider,
    VProgressCircular,
    VSpeedDial,
  },
  theme: {
    primary: '#00A0DD',
    secondary: '#666666',
    accent: '#d9d9d9',
    error: '#F21C2A',
    info: '#BFE7F7',
    success: '#38761d',
    warning: '#bf9000',
    submitBtn: "#37ee4a",
    textColor: "#000000",
    menuBackground: '#0D436B',
    menuText: '#FFFFFF',
    menuSelectedText: '#FFFFFF',
    menuSelectedItem: '#000000',
    appBackground: "#F2F2F2",
  },
  options: {
    customProperties: true,
  },
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  }
})
